import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, retry, switchMap, take, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GeneralService } from './general.service';

@Injectable({
  providedIn: 'root',
})
export class PdfUrlsService {
  constructor(
    private http: HttpClient,
    private generalService: GeneralService,
  ) {}

  public colectionFuntions(quotationId: number, funtion: string, bodyAux?: any): Observable<any> {
    // Plantilla-dealer
    if (funtion === 'plantilla-dealer') {
      return this.loadPdfUrl(quotationId);
    }
    if (funtion === 'getCartaPromesa') {
      return this.getCartaPromesa(quotationId, bodyAux);
    }
    if (funtion === 'buro') {
      return this.convertAssetFileToBase64();
    }
    // FielDocument
    if (funtion === 'FielDocument') {
      return this.getContractByQuote(quotationId);
    }

    return this.http.get<any>(`${environment.apiURLNew}/${funtion}/${quotationId}`).pipe(
      retry({
        count: 5,
        delay: 3000,
      }),
      catchError((error) => {
        this.generalService.viewSnacAlert('Error al cargar el PDF', 'error', 'Reintentando');
        return of(null);
      }),
    );
  }

  private loadPdfUrl(quotationId: string | number): Observable<any> {
    return this.http
      .get<any>(`${environment.apiURLNew}/plantilla-dealer/${quotationId}?asPdf=false`)
      .pipe(
        retry({
          count: 5,
          delay: 3000,
        }),
        catchError((error) => {
          this.generalService.viewSnacAlert(
            'Error al cargar la plantilla del dealer',
            'error',
            'Error',
          );
          return of(null);
        }),
      );
  }

  public getCartaPromesa(quotationId: string | number, ballon: string | number): Observable<any> {
    return this.http
      .get<any>(`${environment.apiURLNew}/getCartaPromesa/${quotationId}/${ballon}`)
      .pipe(
        retry({
          count: 5,
          delay: 3000,
        }),
        catchError((error) => {
          this.generalService.viewSnacAlert('Error al obtener la carta promesa', 'error', 'Error');
          return of(null);
        }),
      );
  }

  // Obtiene los PDFs de los contratos (FielDocument)
  public getContractByQuote(idContract: number): Observable<any | null> {
    return this.http.get<any>(`${environment.apiURLNew}/GetContractByQuote/${idContract}`).pipe(
      retry({
        count: 5,
        delay: 3000,
      }),
      take(1),
      catchError((error) => {
        this.generalService.viewSnacAlert('Error al obtener el contrato', 'error', 'Error');
        return of(null);
      }),
    );
  }

  public convertAssetFileToBase64(): Observable<string> {
    return this.http.get('assets/pdf/ejemplo buro.pdf', { responseType: 'blob' }).pipe(
      retry({
        count: 3,
        delay: 1500,
      }),
      switchMap((blob) => {
        return new Observable<string>((observer) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);

          reader.onloadend = () => {
            const base64 = (reader.result as string).split(',')[1];
            observer.next(base64);
            observer.complete();
          };

          reader.onerror = (error) => observer.error(error);
        });
      }),
      catchError((error) => {
        this.generalService.viewSnacAlert(
          'Error al cargar el archivo base del Buró',
          'error',
          'Error',
        );
        return throwError(() => error);
      }),
    );
  }
}
